import { faFileAudio } from "@fortawesome/pro-regular-svg-icons";
import { faSignalStream } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages/Landing/FeatureCard/FeatureCard";
import { guardWithProps } from "../../components/Routes/Functions/GuardWithProps";
import { lazyRoute } from "../../components/Routes/Functions/LazyRoute";
import { FeatureGuard } from "../../components/Routes/Guards/FeatureGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { Features } from "../feature.enum";
import { IFeature } from "../iFeature";

export const transcriptionFeature: IFeature = {
  id: Features.Transcription,
  route: {
    path: RouteConstants.Transcription,
    lazy: lazyRoute({
      importer: () => import("./TranscriptionPage"),
      componentName: "TranscriptionPage",
      guards: [guardWithProps(FeatureGuard, { role: AppRole.TranscriptionFeature })],
    }),
  },
  menuItem: {
    label: translationKeys.feature.transcription.link,
    breadCrumbTitle: translationKeys.feature.transcription.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Transcription].join("/")}`,
    path: RouteConstants.Transcription,
    showFooter: true,
    icon: () => <FontAwesomeIcon icon={faFileAudio} />,
  },
  card: (
    <FeatureCard
      featureKey={Features.Transcription}
      requiresBudget={true}
      featureIcon={faSignalStream}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Transcription}
    />
  ),
  role: AppRole.TranscriptionFeature,
};
